module.exports = __webpack_public_path__ + "img/observatory.24cc8dad.svg";